import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// lancamentoHoras.service.js
// ════════════════════════════════════════════════════════════════════════════

const lancamentoHorasService = {
  listar: async (filtros = {}) => {
    const res = await api.get('/lancamentos-horas', { params: filtros });
    return res.data;
  },

  criar: async (dados) => {
    const res = await api.post('/lancamentos-horas', dados);
    return res.data;
  },

  alterar: async (id, dados) => {
    const res = await api.put(`/lancamentos-horas/${id}`, dados);
    return res.data;
  },

  excluir: async (id, usuario_id) => {
    const res = await api.delete(`/lancamentos-horas/${id}`, { data: { usuario_id } });
    return res.data;
  },

  buscarColaboradores: async (q) => {
    // r167: era '/lancamentos-horas/buscar-colaboradores'. Referência compartilhada.
    // Mesmo shape ({ id, nome_amigavel, nome }).
    const res = await api.get('/colaboradores/referencia', { params: { q } });
    return res.data;
  },

  opcoesFiltros: async (usuario_id) => {
    const res = await api.get('/lancamentos-horas/opcoes-filtros', { params: { usuario_id } });
    return res.data;
  },

  // r47: capacidade teórica de horas no intervalo
  // r59: cache-buster _t pra invalidar cache HTTP (mesmo problema do calendário)
  horasPrevistas: async (params) => {
    const res = await api.get('/lancamentos-horas/horas-previstas', {
      params: { ...params, _t: Date.now() },
    });
    return res.data;
  },

  marcarCorrigido: async (id, usuario_id) => {
    const res = await api.patch(`/lancamentos-horas/${id}/marcar-corrigido`, { usuario_id });
    return res.data;
  },

  // r76: marca TODOS os 'C' do colaborador em lote → 'X' (Concluir Correções)
  marcarCorrigidoLote: async (colaborador_id, usuario_id) => {
    const res = await api.patch('/lancamentos-horas/marcar-corrigido-lote', {
      colaborador_id, usuario_id,
    });
    return res.data;
  },

  // r52: combo flutuante no browse (P↔X)
  alterarSituacao: async (id, situacao, usuario_id) => {
    const res = await api.patch(`/lancamentos-horas/${id}/situacao`, { situacao, usuario_id });
    return res.data;
  },

  // r50: novos helpers do modal
  // r54: adiciona `_t` (timestamp) pra invalidar cache HTTP do navegador.
  // O endpoint backend também envia Cache-Control: no-cache; o cache-buster
  // é redundância pra garantir que proxies/CDNs intermediários não devolvam
  // resposta antiga (problema observado: excluí lançamento, abri modal de
  // outro do mesmo dia, calendário lateral mostrava o excluído).
  calendarioDoDia: async (colaborador_id, data, ignorar_id) => {
    const params = { colaborador_id, data, _t: Date.now() };
    if (ignorar_id) params.ignorar_id = ignorar_id;
    const res = await api.get('/lancamentos-horas/calendario', { params });
    return res.data;
  },

  projetoLookup: async (id) => {
    const res = await api.get(`/lancamentos-horas/projeto/${id}`);
    return res.data;
  },

  projetosDoCliente: async (cliente_id, q) => {
    const res = await api.get('/lancamentos-horas/projetos-do-cliente', {
      params: { cliente_id, q },
    });
    return res.data;
  },
};

export default lancamentoHorasService;
